import React, { useContext } from 'react'
import { Box, Button, Link, styled, Typography } from '@mui/material'
import { Facebook, Instagram, LinkedIn, X } from '@mui/icons-material';
import ContactPopupForm from './../../common/ContactDialogBox/ContactPopUpForm';
import { ThemeContext } from '../../../context/ThemeContext';

const Heading = styled('h1')(({theme}) => ({
  margin: theme.spacing(5, 0),
  fontSize: '3rem',
  fontFamily: '"Montserrat", sans-serif',
  fontWeight: '300',

  [theme.breakpoints.down('sm')]: {
    fontSize: '2rem',
  }
}));


const CustomIcons = ({ Icon, url }) => {
  return(
    <Link href={url} target="_blank" >
      <Icon
        sx={{
          p: 1,
          fontSize: '1.8rem',
          color: '#55d6aa',
          border: '2px solid #55d6aa',
          borderRadius: '50%',
          '&:hover': { bgcolor: '#55d6aa', color: '#000'}
        }} />
    </Link>
  )
}


function IntroSection() {

  const { setOpenPopUp } = useContext(ThemeContext);

  const socialIcons = [
    {
      icon: Facebook,
      url : "https://www.facebook.com/profile.php?id=61577974327033",
    },
    {
      icon: Instagram,
      url : "https://www.instagram.com/datapi_reaserch/",
    },
    {
      icon: LinkedIn,
      url : "https://www.linkedin.com/company/datapiresearch/",
    },
    {
      icon: X,
      url : "https://x.com/datapi_research",
    },
  ]

  return (
    <Box id="Introduction-section" sx={{ width: '100%', bgcolor: 'white', py: 10 }} >
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        <Heading>Welcome to DataPi</Heading>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }} >
        <Typography sx={{ width: '90%' }} >We transform complex market data into clear, actionable intelligence empowering businesses to make faster, smarter, and future-focused decisions.</Typography>
        <Typography sx={{ width: '90%' }} >Our insights go beyond surface trends built on rigorous research, real-world validation, and tailored to drive measurable impact.</Typography>
        <Typography sx={{ width: '90%' }} >At DataPi, we deliver a powerful blend of company profiling, market analysis, and domain intelligence. With a global scope and regional depth, we serve businesses across industries with tailored insights that simplify complexity and fuel innovation.</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        <Button variant='contained' onClick={ () => setOpenPopUp(true) } sx={{ bgcolor: '#242424', my: 5 }} >Enquiry Now</Button>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 5, gap: 2 }} >
        {
          socialIcons.map((socialIcon, index) => ((
            <CustomIcons key={index} Icon={socialIcon.icon} url={socialIcon.url} />
          )))
        }
      </Box>
    </Box>
  )
}

export default IntroSection
